import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-sugar.css'

Vue.config.productionTip = false
Vue.use(VueAxios, axios)
Vue.use(VueToast);

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')


axios.interceptors.response.use(
  response => response,
  error => {
    // louiza: FIXED - this read error.response.status directly, and error.response is UNDEFINED
    // louiza: whenever the request never reached a server at all: connection refused, DNS failure,
    // louiza: timeout, CORS rejection, or the API simply not running.
    // louiza:
    // louiza: the consequence was worse than a missing message. throwing a TypeError inside a
    // louiza: rejection handler REPLACES the rejection value, so every downstream .catch received
    // louiza: "Cannot read properties of undefined (reading 'status')" instead of the real axios
    // louiza: error. an API that was simply not listening reported itself as a null-property bug in
    // louiza: main.js, which is the wrong place to go looking.
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      window.location.reload();
    }

    // louiza: the original error is passed through untouched, so callers can still tell a transport
    // louiza: failure (no error.response) from an API refusal (error.response.status / .data.message).
    return Promise.reject(error);
  }
);
